import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createPrompt = async (object) => {
  try {
    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.createCustomPrompt, { input: object })
    );
    return response.data.createCustomPrompt;
  } catch (error) {
    console.error("Error creating CustomPrompt:", error);
    throw error;
  }
};

const updatePrompt = async (id, args) => {
  try {
    // First, fetch the current version of the CustomPrompt
    const getCustomPromptResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getCustomPrompt, { id })
    );
    const currentCustomPrompt = getCustomPromptResponse.data.getCustomPrompt;

    // Prepare the update input
    const updateInput = { id, _version: currentCustomPrompt._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.updateCustomPrompt, { input: updateInput })
    );
    return response.data.updateCustomPrompt;
  } catch (error) {
    console.error("Error updating CustomPrompt:", error);
    throw error;
  }
};

const deletePrompt = async (id) => {
  try {
    // First, fetch the current version of the CustomPrompt
    const getCustomPromptResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getCustomPrompt, { id })
    );
    const currentCustomPrompt = getCustomPromptResponse.data.getCustomPrompt;

    return makeGraphQLRequest(
      graphqlOperation(mutations.deleteCustomPrompt, {
        input: { id, _version: currentCustomPrompt._version },
      })
    );
  } catch (error) {
    console.error("Error deleting CustomPrompt:", error);
    throw error;
  }
};

const getCustomPromptsByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.customPromptsByWorkspace, {
      workspaceID: workspaceID,
    })
  );

const getCustomPrompt = (id) =>
  makeGraphQLRequest(
    graphqlOperation(queries.getCustomPrompt, { id })
  );

export default {
  createPrompt,
  updatePrompt,
  deletePrompt,
  getCustomPromptsByWorkspaceID,
  getCustomPrompt,
};
